interface ReferralTrialModalCopyKeys {
  body: string;
  successExpiry: string;
  successCta: string;
}

export const getReferralTrialModalCopyKeys = (
  appToBuild: string
): ReferralTrialModalCopyKeys =>
  appToBuild === "plumbing"
    ? {
        body: "referral.modal.body_plumbing",
        successExpiry: "referral.modal.success_expiry_plumbing",
        successCta: "referral.modal.success_cta_plumbing",
      }
    : {
        body: "referral.modal.body",
        successExpiry: "referral.modal.success_expiry",
        successCta: "referral.modal.success_cta",
      };
